import React from "react";
import EventsAddOrUpdateContent from "../content/EventsAddOrUpdateContent";
import Layout from "../layout/Layout";

const EventsAddOrUpdate = () => {
  return (
    <Layout>
      <EventsAddOrUpdateContent />
    </Layout>
  );
};

export default EventsAddOrUpdate;
